export default __webpack_public_path__ + "close-icon.3faa3158.png";